import { render, staticRenderFns } from "./ConfirmDelete.vue?vue&type=template&id=2817b1a7&scoped=true&"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2817b1a7",
  null
  
)

export default component.exports